import React, { useRef, SyntheticEvent } from "react";

export interface ToggleSwitchInputProps {
  id?: string;
  name: string;
  label?: string;
  checked: boolean;
  onChange: (event: SyntheticEvent) => void;
  className?: string;
  disabled?: boolean;
  onFocus?: (event: SyntheticEvent) => void;
}

export const ToggleSwitchInput: React.FC<ToggleSwitchInputProps> = ({
  id,
  label,
  className,
  name,
  onChange,
  disabled = false,
  ...otherProps
}) => {
  const inputRef: React.RefObject<HTMLInputElement> = useRef(null);

  const disabledClass = disabled ? "disabled" : "";

  return (
    <span
      className={["toggle-switch-wrapper", className, disabledClass]
        .filter(c => !!c)
        .join(" ")}
    >
      <input
        id={id || name}
        name={name}
        data-testid={`${id || name}`}
        onChange={onChange}
        ref={inputRef}
        aria-label={label}
        type="checkbox"
        disabled={disabled}
        {...otherProps}
      />
      <label
        className={`toggle-switch-indicator ${disabled ? "disabled" : ""}`}
        htmlFor={id || name}
        data-testid={`${id || name}-label`}
      />
    </span>
  );
};

export default ToggleSwitchInput;
